import { motion, useSpring } from 'motion/react'
import { useStableScrollProgress } from '../../hooks/useStableScrollProgress'
import { useScrollProgressColor } from '../../providers/ScrollProgressColorProvider'
import { useLocation } from 'react-router-dom'

export interface ScrollProgressIndicatorProps {
  'data-testid': string
}

export default function ScrollProgressIndicator({
  'data-testid': testId
}: Readonly<ScrollProgressIndicatorProps>) {
  const { progressStyle } = useScrollProgressColor()
  const { pathname } = useLocation()
  const { stableProgress } = useStableScrollProgress()

  // default color is red. On the Bfn-details-page it is dependent on the Bfn-Status.
  const progressColorStyle = pathname.startsWith('/befehlsnachrichten')
    ? progressStyle
    : 'bg-red-500 dark:bg-red-600'

  const scaleX = useSpring(stableProgress, {
    stiffness: 250,
    damping: 30,
    restDelta: 0.001
  })

  return (
    <motion.div
      className={progressColorStyle}
      data-testid={testId}
      style={{
        scaleX,
        position: 'relative',
        top: 0,
        left: 0,
        right: 0,
        height: '5px',
        transformOrigin: '0%',
        zIndex: 100
      }}
    />
  )
}
